import SettingFactory from "components/Profiles/SettingFactory";
import NotFooterLayout from "layouts/NotFooterLayout";
import React from "react";

const SettingFactoryPage = () => {
  return (
    <>
      <NotFooterLayout namePage="ตั้งค่าโรงพยาบาล">
        <div className="layout-content">
            <SettingFactory />
        </div>
      </NotFooterLayout>
    </>
  );
};

export default SettingFactoryPage;
